import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/axiosSetup";
import App from "@/App";
import { initKeyboardViewport } from "@/lib/keyboardViewport";
import { registerServiceWorker } from "@/lib/registerServiceWorker";
import { initInstallCapture } from "@/lib/pwaInstall";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

initKeyboardViewport();
initInstallCapture();         // keeps the browser's install prompt until the user asks for it
registerServiceWorker();      // minimal worker: no cache, ready for Web Push (Lot PWA 2)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
